<div class="modal-content modal-content-right">
  <div class="modal-header">
    <h5 class="modal-title"><i class="fas fa-toolbox"></i>ACH Payment</h5>
    <button type="button" class="close" (click)="close()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="justify-content-center">
      <div class="form-row">
        <div class="form-group">
          <span
            >Invoice Number:
            {{
              isMultipleInvoices
                ? selectedInvoiceString
                : manualInvoice.invoiceNumber
            }}</span
          >
          <br />
          <span *ngIf="!isMultipleInvoices"
            >Invoice Date:
            {{ manualInvoice.invoiceDate | date: "MMM-dd-yyyy" }}</span
          >
          <br />
          <strong
            >Amount:
            <div class="input-group">
              <!-- <div class="input-group-prepend">
                <span
                  class="input-group-text"
                  *ngIf="!loadingPartialPaySettings && !busy"
                  >$</span
                >
                <span
                  class="input-group-text"
                  *ngIf="loadingPartialPaySettings || busy"
                  ><i class="fas fa-spinner fa-spin"></i
                ></span>
              </div> -->
              <input
                type="text"
                class="form-control"
                id="amountcharge"
                aria-describedby="amountcharge"
                disabled
                [ngModel]="amountToBePaid | currency"
                class="form-control"
                name="amtpaid"
                placeholder="0.00"
              />
            </div>
          </strong>
          <br />
          <label for="addressId">Select Address</label>
          <select
            [(ngModel)]="addressId"
            class="form-control"
            (change)="addressSelected()"
          >
            <option
              *ngFor="let addr of customerAddresses"
              value="{{ addr.Id }}"
            >
              {{ addr.StreetAddress }} {{ addr.City }} {{ addr.CountryCode }}
              {{ addr.ZipCode }}
            </option>
          </select>
          <a href="#" data-toggle="modal" (click)="addAddress()"
            ><i class="fas fa-plus-circle"></i><span>&nbsp;Add address</span></a
          >
        </div>
        <div
          class="col-md-12"
          *ngIf="!isInitializing && !customerACHDetails.length"
        >
          <span style="color: red"
            ><i>This customer has no ACH Details saved.</i></span
          >
        </div>
        <div class="col-md-12" *ngIf="!isAddACH && customerACHDetails.length">
          <ul class="list-group mt-3">
            <li
              *ngFor="let ach of customerACHDetails"
              class="list-group-item list-group-item-action"
              [class.active]="
                selectedACH &&
                selectedACH.paymentIdentifier === ach.paymentIdentifier
              "
              (click)="onSelectACH(ach.paymentIdentifier)"
            >
              <span
                >****{{ ach.account4Digits }}&nbsp;&nbsp;&nbsp;&nbsp;{{
                  ach.accountType === 0 ? "Checking" : "Savings"
                }}</span
              >
            </li>
          </ul>
        </div>
        <div class="col-md-12 mt-3 mb-3">
          <a href="#" data-toggle="modal" (click)="onAddACH()"
            ><i class="fas fa-plus-circle"></i>&nbsp;<span
              >&nbsp;{{
                !isAddACH
                  ? "Click here to Pay Via new ACH"
                  : "Click here to Pay Via ACH on File"
              }}</span
            ></a
          >
        </div>

        <div class="form-group col-md-12" *ngIf="isAddACH">
          <label class="form-label">Account Number</label>
          <input
            type="text"
            class="form-control"
            [(ngModel)]="achPaymentModel.AccountNumber"
            required
            [ngClass]="{ 'is-invalid': !achPaymentModel.AccountNumber }"
          />
        </div>
        <div class="form-group col-md-12" *ngIf="isAddACH">
          <label class="form-label">Routing Number</label>
          <input
            type="text"
            class="form-control"
            [(ngModel)]="achPaymentModel.RoutingNumber"
            required
            [ngClass]="{ 'is-invalid': !achPaymentModel.RoutingNumber }"
          />
        </div>
        <div class="form-group" *ngIf="isAddACH">
          <label>Account Type</label>
          <select
            name="accountTypeSelect"
            class="form-control"
            [(ngModel)]="achPaymentModel.AccountType"
            (change)="accountTypeChanged($event)"
          >
            <option value="0" selected="true">Checking</option>
            <option value="1">Savings</option>
          </select>
        </div>
        <span *ngIf="isCheckingAccount && isAddACH">
          <div class="form-group col-md-12">
            <label class="form-label">Check Type</label>
            <select
              class="form-control is-invalid"
              [ngClass]="{
                'is-invalid':
                  achPaymentModel.CheckType === '' && isCheckingAccount
              }"
              (change)="checkTypeChanged($event)"
              [(ngModel)]="achPaymentModel.CheckType"
            >
              <option value="">--- Select Check Type ---</option>
              <option value="0">PERSONAL</option>
              <option value="1">BUSINESS</option>
              <option value="2">PAYROLL</option>
            </select>
          </div>
        </span>
        <div class="form-group col-md-12" *ngIf="isAddACH">
          <label class="form-label">Check Holder Name</label>
          <input
            type="text"
            class="form-control"
            [(ngModel)]="achPaymentModel.CheckHolderName"
            required
            [ngClass]="{ 'is-invalid': !achPaymentModel.CheckHolderName }"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <label *ngIf="isAddACH" class="label-chk bold">
            <input type="checkbox" [(ngModel)]="isSaveACH" /> Add ACH to my
            account
          </label>
        </div>
        <div class="col-md-12">
          <label class="label-chk">
            <input type="checkbox" [(ngModel)]="agreedToTerms" /> I have read
            and agree to the
            <a
              class="redify"
              href="javascript:void(0)"
              (click)="openTermsAndCondition()"
              >Terms and Conditions</a
            ><br />
          </label>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline" (click)="close()">
      Cancel
    </button>
    <button
      type="button"
      class="btn btn-outline"
      [disabled]="
        busy ||
        !addressId ||
        loadingPaidDetails ||
        loadingPartialPaySettings ||
        isProcessingPayment
      "
      (click)="
        isMultipleInvoices ? processMultiplePayments() : processPayment()
      "
    >
      Process Payment
      <span class="ml-2" *ngIf="isProcessingPayment"
        ><i class="fas fa-spinner fa-spin"></i
      ></span>
    </button>
  </div>
</div>
